/* eslint-disable no-unused-vars */
import { axiosPublic, axiosPrivate, getLocale } from ".";

export const getPointOfSale = producerId =>
  axiosPrivate.post(
    `ponto_venda/listar`,
    {
      campo: "loja",
      tipo: "string",
      loja: producerId,
    },
    { cache: true }
  );

export const getEquipments = pointOfSales =>
  axiosPrivate.post(`equipamento/listarDisponivel/${pointOfSales}`, {
    cache: true,
  });

export const getChannelSales = () =>
  axiosPrivate.get(`loja/getCanaisVenda/array`, { cache: true });

export const getPaymentMethods = () =>
  axiosPrivate.get(`forma_pagamento/getModosPagamento/array`, { cache: true });

export const getRegionais = () =>
  axiosPrivate.post(`financeiro/regionais/listar`, { cache: true });

export const getConsumer = producerId =>
  axiosPrivate.post(
    `consumidor/listar`,
    {
      loja: producerId,
    },
    { cache: true }
  );

export const getProductTypes = () =>
  axiosPrivate.get(`loja/evento/getTipos/pt/array`, { cache: true });

export const salesByDay = (producerId, params, exportType) =>
  axiosPrivate.post(
    "relatorio/venda/dia",
    {
      loja: producerId,
      exportation: exportType,
      ...params,
    },
    { cache: true, responseType: exportType ? "arraybuffer" : "json" }
  );

export const salesByDayImportExport = (producerId, params) =>
  axiosPrivate.post(
    "relatorio/venda/dia",
    {
      loja: producerId,
      ...params,
    },
    { cache: true }
  );

export const salesByEvent = (producerId, params, exportType) =>
  axiosPrivate.post(
    "relatorio/venda/produto",
    {
      loja: producerId,
      exportation: exportType,
      ...params,
    },
    { cache: true, responseType: exportType ? "arraybuffer" : "json" }
  );

export const salesByTicket = (producerId, params, exportType) =>
  axiosPrivate.post(
    "relatorio/venda/tipo",
    {
      loja: producerId,
      exportation: exportType,
      ...params,
    },
    { cache: true, responseType: exportType ? "arraybuffer" : "json" }
  );

export const salesByChannel = (producerId, params, exportType) =>
  axiosPrivate.post(
    "relatorio/venda/canal",
    {
      loja: producerId,
      exportation: exportType,
      ...params,
    },
    { cache: true, responseType: exportType ? "arraybuffer" : "json" }
  );
export const salesByPaymentMethod = (producerId, params, exportType) =>
  axiosPrivate.post(
    "relatorio/venda/forma",
    {
      loja: producerId,
      exportation: exportType,
      ...params,
    },
    { cache: true, responseType: exportType ? "arraybuffer" : "json" }
  );
export const salesByPointOfSale = (producerId, params, exportType) =>
  axiosPrivate.post(
    "relatorio/ponto_venda/loja",
    {
      loja: producerId,
      exportation: exportType,
      ...params,
    },
    { cache: true, responseType: exportType ? "arraybuffer" : "json" }
  );
export const salesByProduct = (producerId, params, exportType) =>
  axiosPrivate.post(
    "relatorio/venda/produtos",
    {
      loja: producerId,
      exportation: exportType,
      ...params,
    },
    { cache: true, responseType: exportType ? "arraybuffer" : "json" }
  );
export const discountCoupon = (producerId, params, exportType) =>
  axiosPrivate.post(
    "relatorio/cupom/loja",
    {
      loja: producerId,
      exportation: exportType,
      ...params,
    },
    { cache: true, responseType: exportType ? "arraybuffer" : "json" }
  );
export const sendingPackages = (producerId, params, exportType) =>
  axiosPrivate.post(
    "relatorio/venda/taxas",
    {
      loja: producerId,
      exportation: exportType,
      ...params,
    },
    { cache: true, responseType: exportType ? "arraybuffer" : "json" }
  );
export const detailedSalesByEvent = (producerId, params, exportType) =>
  axiosPrivate.post(
    "relatorio/venda/analitico",
    {
      loja: producerId,
      exportation: exportType,
      lang: getLocale(),
      ...params,
    },
    { cache: true, responseType: exportType ? "arraybuffer" : "json" }
  );
export const financialReport = (producerId, params, exportType) =>
  axiosPrivate.post(
    "relatorio/venda/analitico/financeiro",
    {
      loja: producerId,
      exportation: exportType,
      ...params,
    },
    { cache: true, responseType: exportType ? "arraybuffer" : "json" }
  );
export const finalConsumerNF = (producerId, params, exportType) =>
  axiosPrivate.post(
    "relatorio/pedido/nfconsumidorfinal",
    {
      loja: producerId,
      export_csv: exportType === "CSV" ? true : false,
      export_pdf: exportType === "PDF" ? true : false,
      ...params,
    },
    { cache: true, responseType: exportType ? "arraybuffer" : "json" }
  );
export const cancellation = (producerId, params, exportType) =>
  axiosPrivate.post(
    "relatorio/cancelamento",
    {
      loja: producerId,
      exportation: exportType,
      ...params,
    },
    { cache: true, responseType: exportType ? "arraybuffer" : "json" }
  );

export const receivables = (params, exportType) =>
  axiosPrivate.post("relatorio/venda/recebimentos/listagem", params, {
    cache: true,
    responseType: exportType ? "arraybuffer" : "json",
  });

export const receivablesTotal = (params, exportType) =>
  axiosPrivate.post("relatorio/venda/recebimentos/total", params, {
    cache: true,
    responseType: exportType ? "arraybuffer" : "json",
  });

export const receivablesBalance = (params, exportType) =>
  axiosPrivate.post("relatorio/venda/recebimentos/saldos", params, {
    cache: true,
    responseType: exportType ? "arraybuffer" : "json",
  });

export const receivablesExport = (params, exportType) =>
  axiosPrivate.post(
    "relatorio/venda/recebimentos/exportar",
    { exportation: exportType, ...params },
    {
      cache: true,
      responseType: exportType ? "arraybuffer" : "json",
    }
  );

export const affiliates = (producerId, params, exportType) =>
  axiosPrivate.post(
    "loja/afiliado/relatorio",
    {
      loja: producerId,
      exportation: exportType,
      ...params,
    },
    { cache: true, responseType: exportType ? "arraybuffer" : "json" }
  );

export const affiliateDetail = (producerId, params) =>
  axiosPrivate.post(
    "loja/afiliado/relatorio/itens",
    {
      loja: producerId,
      ...params,
    },
    { cache: true }
  );
